/**
 * A consumer of this library can set the validation reporter function
 * to specify how validation errors will be handled.
 * The designated function should expect a message string describing the
 * validation error and a blockId where the validation is failing.
 * @type {Logging}
 */
let logging = require('@sstdev/lib_logging');

function defaultReporter(message){
    logging.warn(message);
}
let reporterSingleton = defaultReporter;

module.exports = {
    /**
     * Consumed by this library to announce validation errors, do not
     * change it directly or you may lose validate messages.
     * Instead use 'setValidationReporter'.
     * @param message
     * @param blockId
     */
    validationReporter: function(message, blockId) {
        reporterSingleton(message, blockId);
    },
    /**
     * Pass in a function which will be called whenever a validation error
     * occurs while processing the metadata.
     * The passed function must accept a message (string) arg and a blockId (string) arg.
     * @param reporter
     */
    setValidationReporter: function(reporter){
        if (typeof reporter !== 'function') {
            throw new Error('"Reporter" must be a function that takes a message string and block Id string.');
        }
        reporterSingleton = reporter;
    },

    revertReporterToDefault: function(){
        reporterSingleton = defaultReporter;
    }
};